import { motion } from 'framer-motion'
import { JoinCtaButton } from '../components/JoinCtaButton'
import { LandingJournalPreview } from '../components/landing/LandingJournalPreview'
import { fadeUp } from '../lib/motion'
import { useT } from '../i18n/t'

export function JournalFeatureSection() {
  const { t } = useT()

  return (
    <section className="container-x py-14 md:py-20">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={{ visible: { transition: { staggerChildren: 0.08 } } }}
        className="content"
      >
        <motion.h2
          variants={fadeUp}
          className="display text-[26px] font-bold leading-[1.1] text-ink md:text-[40px]"
        >
          {t('landing.journalFeature.title')}
        </motion.h2>
        <motion.p
          variants={fadeUp}
          className="mt-3 text-[15px] font-medium text-ink/60 md:text-base"
        >
          {t('landing.journalFeature.subtitle')}
        </motion.p>

        <motion.div variants={fadeUp} className="relative mt-8 md:mt-10">
          <LandingJournalPreview />
        </motion.div>

        <motion.div variants={fadeUp} className="mt-8">
          <JoinCtaButton size="lg">
            {t('landing.journalFeature.cta')}
          </JoinCtaButton>
        </motion.div>
      </motion.div>
    </section>
  )
}
